// Bar chart color and sizing constants

export const PRIMARY_BAR_COLOR = '#532454';
export const PREVIOUS_BAR_COLOR = 'rgba(83,36,84,0.5)';

export const BAR_PERCENTAGE_SMALL = 0.8;
export const BAR_PERCENTAGE_MEDIUM = 0.6;
export const BAR_PERCENTAGE_LARGE = 0.5;
export const BAR_PERCENTAGE_XL = 0.3;

export const CATEGORY_PERCENTAGE_SMALL = 0.9;
export const CATEGORY_PERCENTAGE_MEDIUM = 0.8;
export const CATEGORY_PERCENTAGE_LARGE = 0.7;
export const CATEGORY_PERCENTAGE_XL = 0.6;

export const MAX_BAR_THICKNESS_SMALL = 60;
export const MAX_BAR_THICKNESS_MEDIUM = 40;
export const MAX_BAR_THICKNESS_LARGE = 30;
export const MAX_BAR_THICKNESS_XL = 20;
